/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/PDFImageExtractor.yaml

import { ScanbotPdfImageExtractorImpl } from './impl';
import type { PdfExtractorOptions } from './types/base/PdfExtractorOptions';

/**
 * Entry point for all PDF image extraction features.
 */
export const ScanbotPdfImageExtractor = {
  /**
   * Extract images from a PDF.
   * @param {string} params.pdfFileUri - The file uri of the PDF to extract images from.
   * @param {PdfExtractorOptions} params.options - The options for PDF image extraction.
   * @returns {Promise<string[]>} - The list of file uris to the extracted images.
   */
  async extractImageFiles(params: { pdfFileUri: string; options?: PdfExtractorOptions }): Promise<string[]> {
    return ScanbotPdfImageExtractorImpl.extractImageFiles(params);
  },
};
